// import router from 'vue-router'
import Vue from 'vue'


const actions = {
    updateAmountLocally: ({state, commit, rootGetters, dispatch}, payload) => {
        let incomingOrderProduct = payload.incomingOrderProduct;
        incomingOrderProduct.deviationPresent = true;
        incomingOrderProduct.amount = incomingOrderProduct.amount + payload.amount;
        return dispatch('incomingOrderProducts/patch', incomingOrderProduct, {root: true});
    }
}

export default actions

